module.exports = __webpack_public_path__ + "static/media/tomorrow-edition-2025-social-image.b4c25573.jpg";